/**
 * Opens a PDF blob in a new tab with a named download action.
 * Direct blob: URLs always save as UUID in Chrome's PDF viewer —
 * the download attribute on an <a> is the reliable filename source.
 *
 * Optional preOpenedWin: Fenster im Click-Handler öffnen (wichtig für iOS nach async Arbeit).
 */

function writeViewer(win: Window, url: string, titleSafe: string): void {
  win.document.open();
  win.document.write(`<!DOCTYPE html>
<html lang="de">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>${titleSafe}</title>
  <style>
    html, body { margin: 0; height: 100%; background: #0f172a; font-family: system-ui, sans-serif; }
    .bar {
      display: flex; align-items: center; gap: 10px; flex-wrap: wrap;
      min-height: 52px; padding: 10px 14px; box-sizing: border-box;
      background: #1e293b; color: #e2e8f0; border-bottom: 1px solid #334155;
    }
    .bar span { flex: 1; min-width: 120px; font-size: 12px; opacity: 0.85; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .bar a, .bar button {
      appearance: none; border: 1px solid #64748b; background: #334155; color: #f8fafc;
      border-radius: 8px; padding: 10px 14px; font-size: 13px; font-weight: 700;
      text-decoration: none; cursor: pointer;
    }
    .bar a.primary { background: #f59e0b; border-color: #f59e0b; color: #0f172a; }
    iframe { border: 0; width: 100%; height: calc(100% - 72px); background: #fff; }
  </style>
</head>
<body>
  <div class="bar">
    <span title="${titleSafe}">${titleSafe}</span>
    <button type="button" onclick="document.getElementById('pdfFrame').contentWindow.print()">Drucken</button>
    <a class="primary" href="${url}" download="${titleSafe}">PDF speichern</a>
  </div>
  <iframe id="pdfFrame" title="PDF-Vorschau" src="${url}"></iframe>
</body>
</html>`);
  win.document.close();
}

export function openPdfBlobInNewTab(blob: Blob, filename: string, preOpenedWin?: Window | null): void {
  const safeName = String(filename || 'Dokument.pdf').replace(/"/g, '');
  const url = URL.createObjectURL(blob);
  const titleSafe = safeName.replace(/</g, '').replace(/>/g, '').replace(/"/g, '');

  const win =
    preOpenedWin && !preOpenedWin.closed
      ? preOpenedWin
      : window.open('about:blank', '_blank');

  if (!win) {
    const a = document.createElement('a');
    a.href = url;
    a.download = safeName;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return;
  }

  try {
    writeViewer(win, url, titleSafe);
  } catch {
    try {
      win.location.href = url;
    } catch {
      /* ignore */
    }
  }

  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
}
